export default __webpack_public_path__ + "static/media/FirstBase-6.840ab348.jpg";